<template>
  <div class="question-response p-5 pb-6 card border-rad-1-2">
    <header class="pb-5 is-flex-col align-start">
      <div
        class="px-2 py-1 mb-2 border-rad-1-2"
        :style="{ backgroundColor: colors.gray[4], color: colors.gray[2] }"
      >
        {{ $route.params.section }}.{{ id }}
      </div>
      <h1 class="title is-4">
        {{ question.prompt }}
      </h1>
      <h2 class="subtitle is-6 has-text-grey">
        {{ question.subprompt }}
      </h2>

      <div v-if="question.links">
        <a
          v-for="link in question.links"
          :key="link.name"
          :href="$root.$data.STATIC_ROOT + link.href"
          class="is-size-7"
        >
          {{ link.name }}
        </a>
      </div>
    </header>

    <div>
      <QuestionResponseText
        v-if="isText"
        :responses="question.responses"
        :assigned-colors="assignedColors"
      />
      <QuestionResponseRadioCheckbox
        v-if="isBars"
        :question="question"
        :assigned-colors="assignedColors"
      />
      <QuestionResponseRankOrder
        v-if="isRankOrder"
        :question="question"
        :assigned-colors="assignedColors"
      />

      <div v-if="isUnknown">
        {{ JSON.stringify(question.responses) }}
      </div>
    </div>
  </div>
</template>


<script>
import QuestionResponseText from './QuestionResponseText.vue';
import QuestionResponseRadioCheckbox from './QuestionResponseRadioCheckbox.vue';
import QuestionResponseRankOrder from './QuestionResponseRankOrder.vue';

export default {
  name: 'Question',
  components: { QuestionResponseText, QuestionResponseRadioCheckbox, QuestionResponseRankOrder },
  props: ['question', 'assignedColors', 'prospects', 'id'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    isText() {
      return this.question.type === 'text';
    },
    isBars() {
      return ['radio', 'checkbox'].includes(this.question.type);
    },
    isRankOrder() {
      return this.question.type === 'rankorder';
    },
    isUnknown() {
      const known = ['text', 'radio', 'checkbox', 'rankorder'];
      return !known.includes(this.question.type);
    },
    colors() {
      return this.$root.$data.COLORS;
    },
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {
  },
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
